import axios from 'axios';
import get from 'lodash/get';
import { getUserToken, isLogOutStatus, removeCreds } from './utils';

const instance = axios.create({
  baseURL: `${window.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

instance.interceptors.request.use((config) => {
  const withToken = config.withToken && getUserToken();
  if (withToken) {
    config.headers['x-csrf-token'] = withToken;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = get(error, 'response.status');

    if (isLogOutStatus(status)) removeCreds();

    return Promise.reject(get(error, 'response.data', { statusCode: '000', code: 'NETWORK_ERROR' }));
  },
);

export default instance;
